module.exports = __webpack_public_path__ + "img/fono.b3b00e9d.svg";